/* istanbul ignore file */
import React from 'react';
import EmployeeAssignmentsList from 'domain/people/employee/assignments/List/EmployeeAssignmentsList';

const EmployeeAssignmentsListPage = () => {
  return <EmployeeAssignmentsList />;
};

export default EmployeeAssignmentsListPage;
